import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export const PlanBadge = () => {
  const { user } = useAuth();
  const s = user?.plan_status;
  if (!s) return null;

  const color = !s.is_active
    ? "#FF3B30"
    : s.plan === "yearly"
    ? "#00E676"
    : s.plan === "monthly"
    ? "#00C853"
    : "#FF9F0A";

  const labelText = s.is_active
    ? `${s.status_label} · ${s.days_left}d`
    : "EXPIRED";

  return (
    <Link
      to="/billing"
      data-testid="plan-badge"
      className="flex items-center gap-1.5 px-2 py-1 border border-[#27272A] hover:border-[#3F3F46] transition-colors text-[10px] font-mono"
      title={`Expires ${new Date(s.plan_expires_at).toLocaleDateString()}`}
    >
      <span
        className="w-1.5 h-1.5 rounded-full"
        style={{ background: color }}
      />
      <span style={{ color }}>{labelText}</span>
    </Link>
  );
};
